import React, { useState, useEffect } from "react";
import FullScreenImageViewer from "../../components/FullScreenImageViewer/FullScreenImageViewer";
import "./ProjectModal.css";

function ProjectModal({ project, onClose }) {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [fullscreenOpen, setFullscreenOpen] = useState(false);

  const images = project?.images || [];

  useEffect(() => {
    if (!images.length) return;
    const interval = setInterval(() => {
      setCurrentImageIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1));
    }, 5000);
    return () => clearInterval(interval);
  }, [images]);

  const prevImage = () => {
    setCurrentImageIndex(currentImageIndex === 0 ? images.length - 1 : currentImageIndex - 1);
  };

  const nextImage = () => {
    setCurrentImageIndex(currentImageIndex === images.length - 1 ? 0 : currentImageIndex + 1);
  };

  if (!project) return null;

  return (
    <>
      <div className="modal-overlay" onClick={onClose}>
        <div className="modal-content" onClick={(e) => e.stopPropagation()}>
          <button className="modal-close" onClick={onClose}>×</button>
<div className="modal-text">
  <h2>{project.title}</h2>
  {project.forWho && <p><strong>Sanat Yönetmeni:</strong> {project.forWho}</p>}
  {project.usage && Array.isArray(project.usage) && project.usage.length > 0 && (
    <p><strong>Kullanım Alanı:</strong> {project.usage.join(" ve ")}</p>
  )}
  {project.location && <p><strong>Proje Konumu:</strong> {project.location}</p>}
  {project.completionDate && <p><strong>Tamamlanma Tarihi:</strong> {project.completionDate}</p>}
  {project.area && <p><strong>Yapılan Alan:</strong> {project.area}</p>}
  {project.video && (
    <div className="video-link-box">
      <a href={project.video} target="_blank" rel="noopener noreferrer">
        <strong>Yaptığımız İşi Görmek İçin TIKLAYINIZ</strong>
      </a>
    </div>
  )}
</div>


          <div className="modal-image-slider">
            <button className="nav-arrow left" onClick={prevImage}>‹</button>
            {images[currentImageIndex] && (
              <img
                src={images[currentImageIndex]}
                alt={`image ${currentImageIndex + 1}`}
                className="modal-image"
                onClick={() => setFullscreenOpen(true)}
              />
            )}
            <button className="nav-arrow right" onClick={nextImage}>›</button>
          </div>
        </div>
      </div>

      {fullscreenOpen && (
        <FullScreenImageViewer
          images={images}
          startIndex={currentImageIndex}
          onClose={() => setFullscreenOpen(false)}
        />
      )}
    </>
  );
}

export default ProjectModal;
